import React from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./Auth/PrivateRoute";
import AdminLogin from "./admin_components/AdminLogin";
import AdminDashboard from "./admin_components/AdminDashboard";

import AddArea from "./AreaPriceDetails/AddArea";
import AreaList from "./AreaPriceDetails/AreaList";
import AddPlotGrid from "./AreaPriceDetails/AddPlotGrid";
import PlotList from "./AreaPriceDetails/PlotList";
import CreateCustomer from "./CustomerSection/CreateCustomer";
import CustomerList from "./CustomerSection/CustomerList";

import CustomerRequestedProperty from "./CustomerProperty/CustomerRequestedProperty";
import CustomerPropertyList from "./CustomerProperty/CustomerPropertyList";
import AddCustomerProperty from "./CustomerProperty/AddCustomerProperty";
import CustomerPropertyRejectedList from "./CustomerProperty/CustomerPropertyRejectedList";

import AddEmployee from "./EmployeeSection/AddEmployee";
import Employeelist from "./EmployeeSection/Employeelist";
import EmployeeTree from "./EmployeeSection/EmployeeTree";
import Employeewalletwithdrawrequests from "./EmployeeSection/Employeewalletwithdrawrequests";
import Employeewalletwithdrawlist from "./EmployeeSection/Employeewalletwithdrawlist";
import Employeepercentage from "./EmployeeSection/Employeepercentage";
import Employeewalletamount from "./EmployeeSection/Employeewalletamount";
import Employeetransactionsincentiveslist from "./EmployeeSection/Employeetransactionincentivelist";

import PaymentsReceivedwhenGatewayisDown from "./Invoices_Payments/PaymentReceivedwhengatewayisDown";
import AddManualPaymentReciepts from "./Invoices_Payments/AddManualpaymentreciept";
import Manualpaymentrecieptlist from "./Invoices_Payments/Manualpaymentrecieptlist";
import Monthlyscheduled from "./Invoices_Payments/Monthly_scheduled";
import PaymentsHistory from "./Invoices_Payments/PaymentsHistory";
import AdminChangePassword from "./admin_components/AdminChangePassword";

import CustomersQueries from "./Customerqueries/Customer_queries";

import { AuthProvider } from "./Auth/useAuth";
import AdminRegister from "./AdminRegister";
import AddEmployeewalletamount from "./EmployeeSection/AddEmployeewalletamount";
import AddThirtyPercentForCustomer from "./CustomerProperty/AddThirtyPercentForCustomer";
import ThirtyPercentTransactionsList from "./CustomerProperty/ThirtyPercentTransactionsList";
import Activities from "./Auth/Activities";
import EmployeeView from "./EmployeeSection/EmployeeView";
import EmployeeEdit from "./EmployeeSection/EmployeeEdit";
import CustomerEdit from "./CustomerSection/CustomerEdit";
import CustomerView from "./CustomerSection/CustomerView";

const AdminApp = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/admin_login" element={<AdminLogin />} />
        <Route path="/admin_changepassword" element={<AdminChangePassword />} />

        <Route
          path="activities"
          element={<PrivateRoute element={<Activities />} />}
        />

        <Route
          path="/dashboard"
          element={<PrivateRoute element={<AdminDashboard />} />}
        />
        <Route
          path="/employee-view/:id"
          element={<PrivateRoute element={<EmployeeView />} />}
        />
        <Route
          path="/employee-edit/:id"
          element={<PrivateRoute element={<EmployeeEdit />} />}
        />
        <Route
          path="/add_area"
          element={<PrivateRoute element={<AddArea />} />}
        />
        <Route
          path="/area_list"
          element={<PrivateRoute element={<AreaList />} />}
        />
        <Route
          path="/add_plot_grid"
          element={<PrivateRoute element={<AddPlotGrid />} />}
        />
        <Route
          path="/plot_list"
          element={<PrivateRoute element={<PlotList />} />}
        />

        <Route
          path="/CreateCustomer"
          element={<PrivateRoute element={<CreateCustomer />} />}
        />
        <Route
          path="/CustomerList"
          element={<PrivateRoute element={<CustomerList />} />}
        />

        <Route path="/customer-view/:id" element={<CustomerView />} />
        <Route path="/customer-edit/:id" element={<CustomerEdit />} />

        <Route
          path="/customer_requested_property"
          element={<PrivateRoute element={<CustomerRequestedProperty />} />}
        />
        <Route
          path="/customer_property_list"
          element={<PrivateRoute element={<CustomerPropertyList />} />}
        />
        <Route
          path="/add_customer_property"
          element={<PrivateRoute element={<AddCustomerProperty />} />}
        />
        <Route
          path="/customer_property_rejected_list"
          element={<PrivateRoute element={<CustomerPropertyRejectedList />} />}
        />
        <Route
          path="/admin_register"
          element={<PrivateRoute element={<AdminRegister />} />}
        />

        <Route
          path="/admin_add_employee"
          element={<PrivateRoute element={<AddEmployee />} />}
        />
        <Route
          path="/admin_employeelist"
          element={<PrivateRoute element={<Employeelist />} />}
        />

        <Route
          path="/admin_employee_tree"
          element={<PrivateRoute element={<EmployeeTree />} />}
        />
        <Route
          path="/admin_addemployee_walletamount"
          element={<PrivateRoute element={<AddEmployeewalletamount />} />}
        />
        <Route
          path="/admin_employee_transactions_incentiveslist"
          element={
            <PrivateRoute element={<Employeetransactionsincentiveslist />} />
          }
        />

        <Route
          path="/add_thirty_percent_for_customer"
          element={<PrivateRoute element={<AddThirtyPercentForCustomer />} />}
        />
        <Route
          path="/get_thirty_percent_for_customer"
          element={<PrivateRoute element={<ThirtyPercentTransactionsList />} />}
        />

        <Route
          path="/admin_employee_walletwithdraw_requests"
          element={
            <PrivateRoute element={<Employeewalletwithdrawrequests />} />
          }
        />
        <Route
          path="/admin_employee_walletwithdraw_list"
          element={<PrivateRoute element={<Employeewalletwithdrawlist />} />}
        />
        <Route
          path="/admin_employee_percentage"
          element={<PrivateRoute element={<Employeepercentage />} />}
        />

        <Route
          path="/admin_employee_wallet_Amount"
          element={<PrivateRoute element={<Employeewalletamount />} />}
        />

        <Route
          path="/Monthly_scheduled"
          element={<PrivateRoute element={<Monthlyscheduled />} />}
        />
        <Route
          path="/Payments_History"
          element={<PrivateRoute element={<PaymentsHistory />} />}
        />
        <Route
          path="/Add_Manual_PaymentReciepts"
          element={<PrivateRoute element={<AddManualPaymentReciepts />} />}
        />
        <Route
          path="/Manualpaymentreciept_list"
          element={<PrivateRoute element={<Manualpaymentrecieptlist />} />}
        />
        <Route
          path="/PaymentsReceived_when_GatewayisDown"
          element={
            <PrivateRoute element={<PaymentsReceivedwhenGatewayisDown />} />
          }
        />

        <Route
          path="/Customers_Queries"
          element={<PrivateRoute element={<CustomersQueries />} />}
        />
      </Routes>
    </AuthProvider>
  );
};

export default AdminApp;
